var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dhivehi"},[_c('div',{style:(`height: ${_vm.height ? _vm.height + 'px' : '500px'}`),attrs:{"id":_vm.rootId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }